<template>
    <zen-message-modal :is-open="isOpen" title="Create personal access token">
        <p class="text-sm text-taupe-500 mb-4">
            This token will be able to do anything you can currently do in
            Zenmanage — there are no scopes to choose.
        </p>
        <form @submit.prevent="submit" class="space-y-4">
            <div>
                <label
                    for="pat-name"
                    class="block text-sm font-medium text-taupe-800 mb-1"
                    >Token name</label
                >
                <input
                    type="text"
                    id="pat-name"
                    v-model="form.name"
                    required
                    maxlength="255"
                    placeholder="e.g. My laptop"
                    class="block w-full rounded-md border-taupe-300 bg-white px-3 py-2 text-taupe-900 shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                />
            </div>

            <div>
                <label
                    for="pat-expires"
                    class="block text-sm font-medium text-taupe-800 mb-1"
                    >Expiry date
                    <span class="font-normal text-taupe-500"
                        >(optional)</span
                    ></label
                >
                <input
                    type="date"
                    id="pat-expires"
                    v-model="form.expires_at"
                    :min="minExpiresAt"
                    class="block w-full rounded-md border-taupe-300 bg-white px-3 py-2 text-taupe-900 shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                />
            </div>

            <p v-if="error" class="text-sm text-red-600">
                {{ error }}
            </p>

            <div class="flex justify-end gap-3 pt-2">
                <zen-button
                    type="button"
                    variant="secondary"
                    @click="$emit('close')"
                >
                    Cancel
                </zen-button>
                <zen-button
                    type="submit"
                    variant="primary"
                    :disabled="!form.name.trim()"
                    :processing="processing"
                    processing-label="Creating…"
                >
                    Create token
                </zen-button>
            </div>
        </form>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'CreatePersonalAccessTokenModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
    },
    emits: ['close', 'submit'],
    data() {
        return {
            form: {
                name: '',
                expires_at: '',
            },
        }
    },
    computed: {
        minExpiresAt() {
            const tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)
            const year = tomorrow.getFullYear()
            const month = String(tomorrow.getMonth() + 1).padStart(2, '0')
            const day = String(tomorrow.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
    },
    methods: {
        submit() {
            const payload = { name: this.form.name.trim() }
            if (this.form.expires_at) {
                payload.expires_at = this.form.expires_at
            }
            this.$emit('submit', payload)
        },
    },
}
</script>
